<template>
    <!--  次数退还 -->
    <div>
        <a-modal
            title='次数退还'
            centered
            :visible="visibleCountRefund"
            :width="500"
            :destroyOnClose="true"
            :confirmLoading="confirmLoading"
            @cancel="closeModalCountRefund"
            @ok="handleCountRefund"
            >
            <a-form :form="form">
                <a-form-item label="次数退还/次" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
                    <a-input-number
                        style="width:50%"
                        :min="1"
                        :max="maxNum"
                        :precision="0"
                        placeholder="请输入正整数"
                        v-decorator="['num',{rules: [{required: true, message: '请输入次数'}]}]"
                    />
                    <span class="text-fail ml8">最多可退还 {{maxNum}} 次</span>
                </a-form-item>
                <remark :labelSpan="5" :wrapperSpan="19" operateCode="NumReturn" />
                <a-form-item label="是否发送短信通知" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
                    <a-radio-group v-decorator="['isSendMessage', {rules: [{required: true, message: '请选择'}]}]">
                        <a-radio :value="1">是</a-radio>
                        <a-radio :value="0">否</a-radio>
                    </a-radio-group>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import remark from '@/components/modules/platform/remark.component';
    /**
     * 次数退还组件
     * @prop {Boolean} visibleCountRefund 控制弹窗是否显示
     * @prop {String} id 退还id
     * @prop {Number} maxNum 最多可退还次数
     *
     * @func closeModalCountRefund 通知父组件关闭退款弹窗
     *
     */
    export default {
        name: "count-refund",
        zh: "次数退还组件",
        components: {
            remark
        },
        data() {
            return {
                confirmLoading: false
            };
        },
        computed: {
            ...mapGetters(["shopId", 'shopName'])
        },
        props: {
            visibleCountRefund: {type: Boolean},
            id: {type: String},
            maxNum: {type: Number},
        },
        methods: {
            handleCountRefund() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.confirmLoading = true
                        this.$api.order
                        .countReturn({
                            body: {
                                verifyId: this.id,
                                returnNum: values.num || 1,
                                operateShopId: this.shopId,
                                operateShopName: this.shopName,
                                remark: values.remark,
                                remarkCategoryCode: values.remarkCategoryCode,
                                remarkCategoryName: values.remarkCategoryName,
                                isSendMessage: values.isSendMessage,
                            }
                        })
                        .then(res => {
                            this.confirmLoading = false;
                            this.form.resetFields();
                            this.$message.success("操作成功");
                            this.$emit('closeModal');
                        })
                        .catch(err => {
                            this.confirmLoading = false
                        })
                    }
                })
            },
            closeModalCountRefund() {
                this.$emit('closeModalCountRefund', false);
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this)
        }
    };
</script>

<style lang="scss">
</style>